export default "__VITE_ASSET__BbNQvw$x__"